import React from 'react'
import { isEmpty } from 'lodash'
import { withTranslation } from 'react-i18next'

import { isRatingActive } from './utils'
import { generateNameCSVFile } from '../../utils'
import { getDateTime } from '../../../../utils/dateTime'
import { downloadFile } from '../../../../common/utils/files'
import Loader from '../../../../common/components/Loader/Loader'

import RatingHeader from './components/RatingHeader/RatingHeader'
import RatingData from './components/RatingData/RatingData'

import GAMIFICATION_ACTION_TYPES from '../../../../common/constants/GamificationActionTypes'
import { API__ANALYTICS, API__ACTIONS } from '../../../../api'

import './RatingTable.scss'

const timeFormats = {
    en: 'MMMM D, YYYY (LT)',
    ru: 'D MMMM, YYYY (LT)',
}

class RatingTable extends React.Component {
    constructor(props) {
        super(props)
        this.projectId = props.projectId
        this.blockId = props.blockId
        this.blockTypeId = props.blockTypeId

        this.state = {
            isInitialLoading: true,
            ratings: [],
            selectedRating: null,
            participantsPage: null,
            page: 0,
            isLoading: true,
        }
    }

    async componentDidMount() {
        this.setState({ isLoading: true })
        try {
            const ratingsData = await this.getRatings()
            const latestRating = isEmpty(ratingsData) ? null : ratingsData[ratingsData.length - 1]
            let participantsPage = null
            if (latestRating) {
                const { page } = this.state
                participantsPage = await this.getRatingsOfParticipants({
                    from: latestRating.from,
                    to: latestRating.to,
                    page,
                })
            }

            this.setState({
                ratings: ratingsData,
                selectedRating: latestRating,
                participantsPage: participantsPage,
            })
        } finally {
            this.setState({ isInitialLoading: false, isLoading: false })
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        const { selectedRating, page } = this.state
        const selectedIsChanged = selectedRating !== prevState.selectedRating
        if (selectedIsChanged || page !== prevState.page) {
            this.setState({ isLoading: true })
            try {
                const participantsPage = await this.getRatingsOfParticipants({
                    from: selectedRating.from,
                    to: selectedRating.to,
                    page,
                })

                this.setState({
                    participantsPage: participantsPage,
                })
            } finally {
                this.setState({ isLoading: false })
            }
        }
    }

    getRatings = () =>
        API__ANALYTICS.GET_PROJECT_STATISTICS_BY_ACTION_TYPE({
            projectId: this.projectId,
            blockId: this.blockId,
            actionName: GAMIFICATION_ACTION_TYPES[this.blockTypeId].reset,
        })

    getRatingsOfParticipants = ({ from, to, page }) =>
        API__ANALYTICS.GET_PROJECT_STATISTICS_RATING({
            projectId: this.projectId,
            blockId: this.blockId,
            actionName: GAMIFICATION_ACTION_TYPES[this.blockTypeId].reset,
            from,
            to,
            page,
        })
    getCSV = async () => {
        const { selectedRating } = this.state

        const content = await API__ANALYTICS.GET_BLOCK_RATING_CSV({
            projectId: this.projectId,
            blockId: this.blockId,
            actionName: GAMIFICATION_ACTION_TYPES[this.blockTypeId].finish,
            from: selectedRating.from,
            to: selectedRating.to,
        })

        const fileName = generateNameCSVFile('Ratings', selectedRating.from, selectedRating.to)
        downloadFile(content, `text/csv`, fileName)
    }
    startNewRating = async () => {
        this.setState({ isLoading: true })
        try {
            await API__ACTIONS.CREATE_ACTION({
                projectId: this.projectId,
                blockId: this.blockId,
                actionName: GAMIFICATION_ACTION_TYPES[this.blockTypeId].reset,
            })
            const ratingsData = await this.getRatings()
            const latestRating = isEmpty(ratingsData) ? null : ratingsData[ratingsData.length - 1]
            this.setState({ ratings: ratingsData, selectedRating: latestRating })
        } finally {
            this.setState({ isLoading: false })
        }
    }

    render() {
        const { t } = this.props
        const { isInitialLoading, ratings, selectedRating, participantsPage, isLoading } = this.state

        const startDate = selectedRating && getDateTime(selectedRating.from, timeFormats)
        const endDate = selectedRating && selectedRating.to ? getDateTime(selectedRating.to, timeFormats) : null
        const isHasAnyRatings = !isEmpty(ratings)
        const isHasRatingData = !!participantsPage && !isEmpty(participantsPage.content)
        const isSelectedActiveRating = isRatingActive(selectedRating)
        const countParticipant = participantsPage && participantsPage.totalElements

        return isInitialLoading ? (
            <Loader />
        ) : (
            <div className="leader-board-panel">
                <div className="leader-board-panel__header">
                    <h2>{t('Leader Board')}</h2>
                    {isHasAnyRatings && (
                        <RatingHeader
                            isLoading={isLoading}
                            isHasRatingData={isHasRatingData}
                            getCSV={this.getCSV}
                            startNewRating={this.startNewRating}
                        />
                    )}
                </div>
                <div className="leader-board-panel__rating-list">
                    {ratings.map(rating => {
                        return (
                            <button
                                key={rating.number}
                                className={`leader-board-panel__rating-button 
                            ${selectedRating && selectedRating.number === rating.number ? 'selected' : ''} 
                            ${isRatingActive(rating) ? 'is-active' : ''}`}
                                onClick={() => this.setState({ selectedRating: rating })}
                            >
                                # {rating.number}
                            </button>
                        )
                    })}
                </div>
                <RatingData
                    isHasRatingData={isHasRatingData}
                    isLoading={isLoading}
                    isSelectedActiveRating={isSelectedActiveRating}
                    startDate={startDate}
                    endDate={endDate}
                    countParticipant={countParticipant}
                    participantsPage={participantsPage}
                    onPageChange={page => this.setState({ page })}
                />
            </div>
        )
    }
}

export default withTranslation('translations')(RatingTable)
